import React, { useState, useEffect, useCallback } from 'react';
import styles from './PhotoGallery.module.css';

export default function PhotoGallery({ photos = [] }) {
    const [idx, setIdx]             = useState(0);
    const [fullScreen, setFullScreen] = useState(false);

    const prev = useCallback(() => setIdx((i) => (i - 1 + photos.length) % photos.length), [photos.length]);
    const next = useCallback(() => setIdx((i) => (i + 1) % photos.length), [photos.length]);

    // keyboard navigation when fullscreen
    useEffect(() => {
        if (!fullScreen) return;
        const handler = (e) => {
            if (e.key === 'ArrowLeft')  prev();
            if (e.key === 'ArrowRight') next();
            if (e.key === 'Escape')     setFullScreen(false);
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [fullScreen, prev, next]);

    if (!photos.length) return null;

    return (
        <>
            <div className={styles.gallery}>
                <div className={styles.main} onClick={() => setFullScreen(true)}>
                    <img src={photos[idx]} alt={`protest-${idx}`} className={styles.mainImg} />
                    <span className={styles.zoomHint}>🔍</span>
                    {photos.length > 1 && (
                        <>
                            <button className={`${styles.nav} ${styles.navPrev}`}
                                onClick={(e) => { e.stopPropagation(); prev(); }}>‹</button>
                            <button className={`${styles.nav} ${styles.navNext}`}
                                onClick={(e) => { e.stopPropagation(); next(); }}>›</button>
                        </>
                    )}
                    <span className={styles.counter}>{idx + 1} / {photos.length}</span>
                </div>

                {photos.length > 1 && (
                    <div className={styles.thumbs}>
                        {photos.map((src, i) => (
                            <button
                                key={i}
                                className={`${styles.thumb} ${i === idx ? styles.thumbActive : ''}`}
                                onClick={() => setIdx(i)}
                            >
                                <img src={src} alt={`thumb-${i}`} />
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {fullScreen && (
                <div className={styles.overlay} onClick={() => setFullScreen(false)}>
                    <div className={styles.overlayContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeBtn} onClick={() => setFullScreen(false)}>✕</button>
                        <img src={photos[idx]} alt={`fullscreen-${idx}`} className={styles.overlayImg} />
                        {photos.length > 1 && (
                            <>
                                <button className={`${styles.overlayNav} ${styles.overlayPrev}`} onClick={prev}>‹</button>
                                <button className={`${styles.overlayNav} ${styles.overlayNext}`} onClick={next}>›</button>
                            </>
                        )}
                        <p className={styles.overlayCounter}>{idx + 1} / {photos.length}</p>
                    </div>
                </div>
            )}
        </>
    );
}
